module.exports = __webpack_public_path__ + "img/review-green.8cbb14da.svg";